import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { RouterAddress } from "../../constants/RouterAddress";
import {
  appAccentPanelStyle,
  appDialogContentStyle,
  appDialogHeaderStyle,
  appDialogStyle,
  appMutedTextStyle,
  appNeutralPanelStyle,
  renderSurfaceHeader,
} from "./uiSurfaceStyles";

type SubscribeForUnlimitedAccessDialogProps = {
  visible: boolean;
  onHide: () => void;
  title: string;
  message: string;
  billingPath?: string;
  billingButtonLabel?: string;
};

const SubscribeForUnlimitedAccessDialog = ({
  visible,
  onHide,
  title,
  message,
  billingPath = RouterAddress.BILLING,
  billingButtonLabel = "Go To Billing",
}: SubscribeForUnlimitedAccessDialogProps) => {
  const navigate = useNavigate();

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={renderSurfaceHeader(title, "Upgrade your access or open Billing to review your options.", "pi pi-lock")}
      style={appDialogStyle}
      headerStyle={appDialogHeaderStyle}
      contentStyle={appDialogContentStyle}
      breakpoints={{ "960px": "90vw" }}
      modal
    >
      <div className="flex flex-column gap-3">
        <div style={appAccentPanelStyle}>
          <div style={{ fontWeight: 700, color: "#9a3412" }}>Access limit reached</div>
          <div className="mt-2" style={appMutedTextStyle}>
            {message}
          </div>
        </div>
        <div style={appNeutralPanelStyle}>
          <div style={{ fontWeight: 700, color: "#0f172a" }}>What you can do next</div>
          <div className="mt-2" style={appMutedTextStyle}>
            Open Billing to subscribe and get back to publishing your home on the web.
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-content-end gap-2">
        <Button label="Close" severity="secondary" outlined rounded onClick={onHide} />
        <Button
          label={billingButtonLabel}
          severity="warning"
          rounded
          onClick={() => {
            onHide();
            navigate(billingPath);
          }}
        />
      </div>
    </Dialog>
  );
};

export default SubscribeForUnlimitedAccessDialog;
